
export default class FadeInOutImages {
    constructor(elm) {
        this.elm = elm;

        this.images = elm.querySelectorAll('[data-image]');
        this.activeIndex = 0;

        this.init();
    }

    init() {

        this.images.forEach((image, index) => {

            if(index==this.activeIndex) {
                this.showImage(image);
            } else {
                this.hideImage(image);
            }

            image.addEventListener('click',(e) => {
                this.showImage(image);

                if (e.currentTarget.previousElementSibling) {
                    this.hideImage(e.currentTarget.previousElementSibling)
                }

                if (e.currentTarget.nextElementSibling) {
                    this.hideImage(e.currentTarget.nextElementSibling)
                }
            });

            image.addEventListener('mouseenter',(e) => {
                this.showImage(image);

                if (e.currentTarget.previousElementSibling) {
                    this.hideImage(e.currentTarget.previousElementSibling)
                }

                if (e.currentTarget.nextElementSibling) {
                    this.hideImage(e.currentTarget.nextElementSibling)
                }
            });
        });
    }

    showImage(image) {
        image.classList.add('m-two-images__image--visible');
    }

    hideImage(image) {
        image.classList.remove('m-two-images__image--visible');
    }
}
